import { Extension } from "../constants/extension";
import { AssetType } from "../models/assets/asset";

export enum ImageSize {
	THUMBNAIL = 'thumbnail',    // 150x225px (2:3) for small cards
	CARD = 'card',             // 200x300px (2:3) for standard cards  
	DETAIL = 'detail',         // 400x600px (2:3) for detail views
	GALLERY = 'gallery',       // 600x400px (3:2) for gallery images
	LOGO_SMALL = 'logo-small', // 64x64px for compact displays
	LOGO = 'logo',            // 120x120px for card headers
	HERO = 'hero'             // 800x600px for featured content
}

export enum EntityType {
	PRODUCT = 'product',
	MINISTRY = 'ministries',
	EVENT = 'events',
	BOOK = 'books',
	SCHOOL = 'schools'
}

class MediaService {

	/***************
	 * Media
	 **************/
	private static readonly MEDIA_URL = "https://assets.zoeforallnations.com"
	/***************
	 * Products
	**************/
	public getMediaUrl(type: EntityType,
				name: string,
				assetType: AssetType,
				extension: Extension = Extension.JPEG,
				imageIndex?: number,
				size?: ImageSize): string {
		
		let fileName: string = assetType;
		
		if (assetType === AssetType.IMAGE && imageIndex !== undefined) {
			const paddedIndex = imageIndex.toString().padStart(2, '0');
			fileName = `${assetType}-${paddedIndex}`;
		}
			
		return `${MediaService.MEDIA_URL}/${type}/${name}/${fileName}.${extension}`;
	}

}

export const mediaService = new MediaService();